import { render, staticRenderFns } from "./GameCardKs.vue?vue&type=template&id=7a38271a"
import script from "./GameCardKs.vue?vue&type=script&lang=js"
export * from "./GameCardKs.vue?vue&type=script&lang=js"
import style0 from "./GameCardKs.vue?vue&type=style&index=0&id=7a38271a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports